import * as React from "react"
import { Check, ChevronsUpDown } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command"
import { Popover, PopoverContent, PopoverTrigger} from "@/components/ui/popover"

export interface UserOption {
    id: string;
    name: string;
}

interface ComboBoxUserSelectProps {
    users: UserOption[];
    value: string;
    placeholder?: string;
    onChange: (id: string) => void;
}

export function ComboBoxUserSelect({
    users,
    value,
    placeholder = "Seleccionar sup..",
    onChange,
}: ComboBoxUserSelectProps) {
    const [open, setOpen] = React.useState(false);
    const [search, setSearch] = React.useState("");

    const selectedLabel = value
        ? users.find((u) => u.id === value)?.name
        : placeholder;

    const filteredUsers = users.filter((user) => {
        const searchLower = search.toLowerCase();
        return (
            user.name.toLowerCase().includes(searchLower) ||
            user.id.toLowerCase().includes(searchLower)
        );
    });

    const handleOpenChange = (nextOpen: boolean) => {
        setOpen(nextOpen);
        if (!nextOpen) setSearch("");
    };

    return (
        <Popover open={open} onOpenChange={handleOpenChange}>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    role="combobox"
                    aria-expanded={open}
                    className="w-full justify-between"
                >
                    {selectedLabel}
                    <ChevronsUpDown className="opacity-50 ml-2 h-4 w-4" />
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-full p-0">
                <Command>
                    <CommandInput
                        placeholder={`Search ${placeholder.toLowerCase()}`}
                        className="h-9"
                        value={search}
                        onValueChange={(val) => setSearch(val)}
                    />
                    <CommandList>
                        <CommandEmpty>No se encontro resultados.</CommandEmpty>
                        <CommandGroup>
                            {filteredUsers.map((user) => (
                                <CommandItem
                                    className="cursor-pointer"
                                    key={user.id}
                                    value={user.name}
                                    onSelect={() => {
                                        onChange(user.id === value ? '' : user.id);
                                        setOpen(false);
                                        setSearch("");
                                    }}
                                >
                                    {user.name}
                                    <Check
                                        className={cn(
                                            "ml-auto h-4 w-4",
                                            value === user.id ? "opacity-100" : "opacity-0"
                                        )}
                                    />
                                </CommandItem>
                            ))}
                        </CommandGroup>
                    </CommandList>
                </Command>
            </PopoverContent>
        </Popover>
    );
}
